import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");

    if (!token) {
        return React.createElement(Navigate, {
            to: "/",
            replace: true,
        });
    }

    return children;
};

export default ProtectedRoute;